'use client';

import type { AnalyticsPort } from '@/core/ports/analytics';
import { noopAnalytics } from './noop';
import { umamiAnalytics } from './umami';

export function getAnalyticsClient(): AnalyticsPort {
  const provider = process.env.NEXT_PUBLIC_ANALYTICS_PROVIDER;
  if (provider === 'umami') {
    return umamiAnalytics;
  }
  return noopAnalytics;
}

export const analytics = getAnalyticsClient();
